<template>
  <validation-provider
    name="payment-method"
    rules="required"
    v-slot="{ errors }">
    <div
      :class="{
        'form-control': true,
        'is-select': true,
        'is-invalid': errors.length,
        'vs-wrap-text': true
      }">
      <v-select
        :options="paymentsList"
        :disabled="disabled"
        v-model="payment_id"
        :reduce="(payment) => payment.id"
        placeholder="Wybierz metodę płatności"
        label="name">
        <template slot="no-options">
          Brak metod płatności dla tego klienta
        </template>
      </v-select>
    </div>
    <div class="invalid-feedback">
      {{ errors[0] }}
    </div>
  </validation-provider>
</template>

<script>

export default {
  name: 'order-payment-select',
  props: [
    'disabled'
  ],
  data () {
    return {
      payment_id: null,
      paymentsList: []
    }
  },
  mounted () {
    this.$bus.$on('order-update-payment-list', this.updatePaymentList);
    this.$bus.$on('order-set-default-payment', this.setDefaultPayment);
  },
  methods: {
    updatePaymentList (clientPaymentsList = [], paymentID = null) {
      this.paymentsList = clientPaymentsList;
      this.payment_id = paymentID;

      if (paymentID === null && clientPaymentsList.length === 1) {
        this.payment_id = clientPaymentsList[0].id;
      }
    },
    setDefaultPayment (paymentID) {
      this.payment_id = paymentID;
    }
  },
  beforeDestroy() {
    this.$bus.$off('order-update-payment-list', this.updatePaymentList);
    this.$bus.$off('order-set-default-payment', this.setDefaultPayment);
  }
}

</script>
